import { defineComponent as _defineComponent } from 'vue'
import TabItem from "../component/tab-item.vue";
import TabContent from "../component/tab-content.vue";
import Collapse from "../../../../Collapse/index.vue";
import { computed, ref, onMounted } from "vue";
import { Layer } from "mapbox-gl";
import { TABS, DEFAULT_VALUE, convertTabWithDefaultConfig } from "./type";
import { Tab, TabConfig } from "@/interface/style";
import { inputSlider } from "@/components/input";

export default /*#__PURE__*/_defineComponent({
  __name: 'single-style',
  props: {
  value: {
    required: true
  },
  trans: {
    required: true
  },
  mapId: {
    required: true
  }
},
  emits: ["input", "update-style"],
  setup(__props, { emit }) {

const props = __props



const layer = computed<Layer>({
  get() {
    return props.value as Layer;
  },
  set(value) {
    emit("input", value);
  }
});
const tabs_format = computed<TabConfig[]>(() => {
  const tab = TABS[layer.value.type];
  if (tab.type === "multi") {
    return tab.tabs.map((x) => ({
      ...x,
      items: convertTabWithDefaultConfig(x.items)
    }));
  }
  return [
    {
      type: "single",
      text: "style",
      items: convertTabWithDefaultConfig(tab.items)
    }
  ];
});
const default_value = computed(() => DEFAULT_VALUE[layer.value.type]);
const tab_group = ref<TabConfig | undefined>(undefined);
const tab = ref<Tab | undefined>(undefined);
const onSelectTab = (item: Tab) => {
  tab.value = item;
  if (tab.value && (tab.value as any).menu) {
    (tab.value as any).menu = (tab.value as any).menu.map((x: any) => ({
      ...x,
      text: x.text || (props.trans as any)(x.text_trans || "") || "",
      subtitle: x.subtitle || (props.trans as any)(x.subtitle_trans || "") || ""
    }));
  }
};
const onSelectTabGroup = (group: TabConfig) => {
  tab_group.value = group;
  if (tab_group.value && tab_group.value.items)
    onSelectTab(tab_group.value.items[0]);
};
const emitInput = (value: any, tab: Tab, layer: any) => {
  if (tab.type === "divider") {
    return;
  }
  if (tab.format) {
    value = tab.format(value);
  }
  layer[tab.part || "paint"][tab.key] = value;
  emit("update-style", layer);
};
onMounted(() => {
  if (tabs_format) onSelectTabGroup(tabs_format.value[0]);
});
const onChangeMinZoom = (zoom: number, layer: any) => {
  layer["min-zoom"] = zoom;
  emit("update-style", layer);
};
const onChangeMaxZoom = (zoom: number, layer: any) => {
  layer["max-zoom"] = zoom;
  emit("update-style", layer);
};

return { __sfc: true,props, emit, layer, tabs_format, default_value, tab_group, tab, onSelectTab, onSelectTabGroup, emitInput, onChangeMinZoom, onChangeMaxZoom, TabItem, TabContent, Collapse, inputSlider }
}

})